import React, { useState } from 'react';
import Input from 'Components/Form/Input';
import PrimaryButton from 'Components/Button/PrimaryButton';
import Auth from 'Services/Api/Auth/Auth';
import { Alert, Loading } from 'Components/Partials';
import SecondaryButton from "Components/Button/SecondaryButton";
import Link from "Components/Utilities/Link";
import UnAuthHeader from "Components/Layouts/TopMenu/UnAuthHeader";
import Header from "Components/Layouts/TopMenu/Header";

export default function Join() {
  const [step, setStep] = useState('email'); // 'email' | 'password' | 'lite'
  const [form, setForm] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    job_title: '',
    country: '',
    company_name: '',
  });
  const [errors, setErrors] = useState(null);
  const [working, setWorking] = useState(false);
  const [message, setMessage] = useState('');
  const [hasPassword, setHasPassword] = useState(null);

  // new: simple back handler to return to the email step and clear state
  const handleBack = () => {
    setStep('email');
    setErrors(null);
    setMessage('');
  };

  const handleInput = (name, value) => setForm(prev => ({ ...prev, [name]: value }));

    const submitEmail = async () => {
        setWorking(true); setErrors(null); setMessage('');
        try {
            const res = await Auth.checkEmail({ email: form.email });

            // If backend sent a redirect (auto-login case), navigate immediately.
            const redirect = res?.data?.redirect ?? res?.redirect;
            if (redirect) {
              window.location.href = redirect;
              return;
            }

            // normalize possible shapes: res.data.exists or res.exists
            const exists = res?.data?.exists ?? res?.exists;
            // normalize has_password flag
            const has_password = res?.data?.has_password ?? res?.has_password;
            setHasPassword(typeof has_password === 'boolean' ? has_password : null);

            setWorking(false);

            if (typeof exists === 'boolean') {
                setStep(exists ? 'password' : 'lite');
                return;
            }

            if (res?.errors) {
                setErrors(res.errors);
                return;
            }

            setMessage(res?.message || 'Something went wrong. Please try again.');
        } catch (err) {
            setWorking(false);
            setMessage('Something went wrong. Please try again.');
        }
    };

  const submitPassword = async () => {
    setWorking(true); setErrors(null); setMessage('');
    const res = await Auth.login({ email: form.email, password: form.password });
    setWorking(false);
    if (res?.status === 201 || res?.success) {
      window.location.href = '/main-stage';
    } else if (res?.errors) {
      setErrors(res.errors);
    } else if (res?.message) {
      setMessage(res.message);
    } else {
      setMessage('Invalid credentials');
    }
  };

  const submitLite = async () => {
    setWorking(true); setErrors(null); setMessage('');
    const res = await Auth.liteRegister({
      email: form.email,
      first_name: form.first_name,
      last_name: form.last_name,
      job_title: form.job_title,
      country: form.country,
      company_name: form.company_name,
    });
    setWorking(false);
    if (res?.status === 201 || res?.success) {
      window.location.href = '/main-stage';
    } else if (res?.errors) {
      setErrors(res.errors);
    } else if (res?.message) {
      setMessage(res.message);
    } else {
      setMessage('Could not complete registration. Please try again.');
    }
  };

  const renderEmailStep = () => (
    <div className="max-w-xl mx-auto w-full">
      <h1 className="text-center mb-4 font-bold text-2xl">
          Join the stream
      </h1>
      <Input
        name="email"
        type="email"
        label="Email"
        value={form.email}
        onChange={v => handleInput('email', v)}
        error={errors?.email}
        className="w-full"
        containerClassName="w-full mb-4"
        labelColour={"text-app-blue"}
      />
      <div className="flex justify-center">
        <PrimaryButton onClick={submitEmail} text="Continue" />
      </div>
    </div>
  );

  const renderPasswordStep = () => (
    <div className="max-w-xl mx-auto w-full">
        <h1 className="text-center mb-4 font-bold text-2xl">
            Welcome back. Enter your password to continue
        </h1>
          <Input
            name="password"
            type="password"
            label="Password"
            value={form.password}
            onChange={v => handleInput('password', v)}
            error={errors?.password}
            className="w-full"
            containerClassName="w-full mb-2"
            labelColour={"text-app-blue"}
          />
        {hasPassword && (
            <Link to={"/password/request"}>
                <button className="mt-4 block text-center text-app-blue mb-4" onClick={() => setStep('lite')}>
                    Reset Password
                </button>
            </Link>
        )}
      <div className="flex justify-center">
        <PrimaryButton onClick={submitPassword} text="Login" />
      </div>
          {!hasPassword && (
            <button className="mt-4 block" onClick={() => setStep('lite')}>
              I don’t know my password
            </button>
          )}
        <div className="flex justify-center mt-4">
            <SecondaryButton onClick={handleBack} text="Back" />
        </div>
    </div>
  );

  const renderLiteStep = () => (
    <div className="max-w-xl mx-auto w-full">
        <h1 className="text-center mb-4 font-bold text-2xl">Almost there. Please provide a few details.</h1>
        <Input name="first_name" label="First name" required value={form.first_name} onChange={v => handleInput('first_name', v)} error={errors?.first_name} className="w-full" containerClassName="w-full mb-4" labelColour={"text-app-blue"} />
        <Input name="last_name" label="Last name" required value={form.last_name} onChange={v => handleInput('last_name', v)} error={errors?.last_name} className="w-full" containerClassName="w-full mb-4" labelColour={"text-app-blue"}  />
        <Input name="job_title" label="Job title" value={form.job_title} onChange={v => handleInput('job_title', v)} error={errors?.job_title} className="w-full" containerClassName="w-full mb-4" labelColour={"text-app-blue"}  />
        <Input name="country" label="Country" value={form.country} onChange={v => handleInput('country', v)} error={errors?.country} className="w-full" containerClassName="w-full mb-4" labelColour={"text-app-blue"}  />
        <Input name="company_name" label="Company" value={form.company_name} onChange={v => handleInput('company_name', v)} error={errors?.company_name} className="w-full" containerClassName="w-full mb-4" labelColour={"text-app-blue"}  />
        <div className="flex justify-center">
          <PrimaryButton onClick={submitLite} text="Join the stream" />
        </div>
        <div className="flex justify-center mt-4">
            <SecondaryButton onClick={handleBack} text="Back" />
        </div>
    </div>
  );

  return (
      // make the container a column flex so Header stays on top
      <div className="min-h-screen flex flex-col bg-app-blue">
        <Header pageVideoHeader={ "bupa-banner.mp4" } />

        {/* main grows to fill remaining space and centers its content */}
        <main className=" flex items-center justify-center w-full px-4 text-app-blue mt-10">
          <div className="bg-white p-3 py-6 w-full max-w-3xl rounded-2xl">
              {working && <Loading />}
              {message && <Alert type="info" message={message} className="mb-4" />}
              {!working && step === 'email' && renderEmailStep()}
              {!working && step === 'password' && renderPasswordStep()}
              {!working && step === 'lite' && renderLiteStep()}
          </div>
        </main>
      </div>
  );
}
